import React, { useRef } from 'react';
import { ResultModal } from './v2/ResultModal.styles';
import PreventivassCardNoAquista from '../../elements/quote/cards/PreventivassCardNoAquista';
import RiskCard from '../Cards/RiskCard';
import QuotationCard from '../../../reusable/QuotationCard';
import { commercialExtraQuoteTypes, commercialTypes } from '../../../constants';

// match: show quote only when processingQuote.company_id matches quote.company_id and is in this list
// always: show quote regardless of processingQuote.company_id
const RISK_CARD_CONFIG = {
  assistenza_stradale: { match: [1, 17, 9, 18, 1000], always: [16, 8, 1001, 1005] },
  eventi_naturali: { match: [1, 17, 1000], always: [16, 8, 1001] },
  eventi_socio_politici: { match: [1, 17, 1000], always: [16, 8, 1001] },
  tutela_legale: { match: [1, 17, 9, 18, 1000], always: [16, 8, 15, 1001, 1005] },
  rc_transportati_minori: { match: [9], always: [] },
  infortuni_conducente: { match: [1, 17, 9, 18, 1000], always: [16, 8, 1001] },
  rivalsa: { match: [1, 17, 9, 18, 1000], always: [16, 8, 1001] },
  cristalli: { match: [1, 17, 1000, 18], always: [16, 8, 1001] },
  furto_incendio: { match: [1, 17, 18, 1000], always: [16, 1001] },
  ricordo_terzi_da_incendio: { match: [1, 17], always: [1001] },
  collisione: { match: [1, 17, 1000], always: [8, 1001] },
  bonus_protetto: { match: [1000, 1001, 18], always: [] },
  estensione_deluxe: { match: [1000], always: [] },
  kasko: { match: [1000], always: [1001] },
  pacchetto_eco: { match: [1000], always: [] },
  pacchetto_protezione_valore: { match: [1000], always: [] },
  protezione_mobilita: { match: [1000], always: [] },
  quattrozampe_a_bordo: { match: [1000], always: [] },
  kasko_collisione: { match: [], always: [1005] },
};

// Types that only show quotes from company 1001
const BUSINESS_1001_TYPES = [
  'business_assistance', 'other_property_damage_bucket_rate', 'cristalli',
  'furto_incendio', 'business_electronics', 'content_theft', 'incendio_contentuto',
  'incendio_fabbricato', 'fire_bucket_rate', 'refrigeration_goods',
  'third_party_recourse', 'rental_risk',
];

// Company 16 (Genial Piu) quotes are only shown when the main quote is also company 16
function isCompanyAllowed(quote, processingQuote) {
  if (quote.company_id === 18 && processingQuote?.company_id !== 18) return false;
  return true;
}

function isRiskQuoteVisible(quote, processingQuote, config) {
  if (!isCompanyAllowed(quote, processingQuote)) return false;
  const { match, always } = config;
  return always.includes(quote.company_id)
    || (match.includes(processingQuote.company_id) && quote.company_id === processingQuote.company_id);
}

function ModalQuotes({
  type,
  addingQuote,
  // sortBy,
  // sortQuotes,
  currentQuotes,
  requestInfo,
  // counter,
  quotations,
  selectQuotation,
  guaranteesPrima,
  preventivas_quotes,
  processingQuote,
  riskQuotes,
  refresh,
}) {
  const closeButtonRef = useRef(null);

  const closeButton = () => {
    if (closeButtonRef.current) {
      closeButtonRef.current.click();
    }
  };

  const selectQuote = (quoteId) => selectQuotation(quoteId, closeButton);

  const typeQuotes = quotations?.[type.id];

  const renderRiskCard = (quote, index, overrideType) => (
    <div className="col-12 mb-2" key={index}>
      <RiskCard
        quote={quote}
        type={overrideType ?? type}
        selectQuotation={selectQuote}
        requestInfo={requestInfo}
        riskQuotes={riskQuotes}
      />
    </div>
  );

  return (
    <ResultModal
      className="modal fade"
      id={type.id}
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              {type.name}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="buttonClose"
              ref={closeButtonRef}
            />
          </div>
          <div className="modal-body">
            {addingQuote && (
              <div className="d-flex align-items-center justify-content-between flex-column">
                <div className="d-flex justify-content-center">
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Aggiungendo...</span>
                  </div>
                </div>
                <div className="ms-2">Aggiungendo...</div>
              </div>
            )}
            {addingQuote === false && (
              <>
                <div className="row mb-4">
                  {/* {type.id === 'res_civile' && requestInfo.product_id == 1 && (
                    <div className="col-12 mb-2">
                      <div className="dropdown purchase-quote-fourth-step">
                        <button
                          className="btn btn-success dropdown-toggle"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          Ordinato Per:
                          {' '}
                          {sortBy === 'amount' ? 'Premio' : 'Indice Di Qualità'}
                        </button>
                        <ul className="dropdown-menu mt-2">
                          <li
                            style={{ cursor: 'pointer' }}
                            onClick={() => sortQuotes(sortBy === 'amount' ? 'coefficente' : 'amount')}
                          >
                            <a className="dropdown-item">
                              {sortBy === 'amount' ? 'Indice Di Qualità' : 'Premio'}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )} */}
                  {/* {type.id === 'res_civile'
                    && requestInfo.product_id == 1
                    && requestInfo.with_preventivas === null && (
                      <div className="d-flex align-items-center justify-content-center mb-2 preventivas-counter">
                        <QuoteLoader>{counter}</QuoteLoader>
                        {' '}
                        <span className="ms-2">Recuperando più preventivi...</span>
                      </div>
                  )} */}
                </div>

                <div className="row purchase-quote-eight-step">
                  {/* res_civile: diretta / indiretta */}
                  {type.id === 'res_civile'
                    && quotations
                    && typeQuotes
                    && (currentQuotes === 'diretta' || currentQuotes === 'indiretta')
                    && typeQuotes.map((quote, index) => (
                      <React.Fragment key={index}>
                        {currentQuotes === 'diretta' && (
                          <>
                            {((quote.company_id === null && quote.added_manually === 1)
                              || (quote.company_id !== null && quote.added_manually == 0)) && (
                                <div className="col-12 mb-2">
                                  <QuotationCard
                                    quote={quote}
                                    selectQuotation={selectQuote}
                                    requestInfo={requestInfo}
                                    guaranteesPrima={guaranteesPrima}
                                    refresh={refresh}
                                  />
                                </div>
                            )}
                            {quote.product_id === 10 && (
                              <div className="col-12 mb-2">
                                <QuotationCard
                                  quote={quote}
                                  selectQuotation={selectQuote}
                                  requestInfo={requestInfo}
                                />
                              </div>
                            )}
                          </>
                        )}
                        {currentQuotes === 'indiretta'
                          && quote.company_id === null
                          && quote.added_manually == 0 && (
                            <div className="col-12 mb-2">
                              <QuotationCard
                                requestInfo={requestInfo}
                                quote={quote}
                                selectQuotation={selectQuote}
                              />
                            </div>
                        )}
                      </React.Fragment>
                    ))}

                  {/* res_civile: quotazioni */}
                  {currentQuotes === 'quotazioni' && preventivas_quotes.map((quote, index) => (
                    <div className="col-12 mb-2" key={index}>
                      <PreventivassCardNoAquista requestInfo={requestInfo} quotation={quote} />
                    </div>
                  ))}
                  {currentQuotes === 'quotazioni'
                    && type.id === 'res_civile'
                    && (quotations === null || quotations[type.id] === null) && (
                      <h5 className="fw-bold">Nessuna Quotazione Trovata</h5>
                  )}

                  {/* Standard risk card types filtered by per-type company ID config */}
                  {RISK_CARD_CONFIG[type.id] && quotations && typeQuotes && (
                    <div>
                      {processingQuote !== null ? (
                        typeQuotes
                          .filter((quote) => isRiskQuoteVisible(quote, processingQuote, RISK_CARD_CONFIG[type.id]))
                          .map((quote, index) => renderRiskCard(quote, index))
                      ) : (
                        <h5 className="fw-bold">Nessuna Quotazione Trovata</h5>
                      )}
                    </div>
                  )}

                  {/* Types that only show company 1001 quotes */}
                  {BUSINESS_1001_TYPES.includes(type.id) && quotations && typeQuotes && (
                    <div>
                      {processingQuote !== null ? (
                        typeQuotes
                          .filter((quote) => processingQuote.company_id === 1001 && quote.company_id === 1001)
                          .map((quote, index) => renderRiskCard(quote, index))
                      ) : (
                        <h5 className="fw-bold">Nessuna Quotazione Trovata</h5>
                      )}
                    </div>
                  )}

                  {/* Commercial types */}
                  {processingQuote !== null
                    && processingQuote.company_id !== 1001
                    && commercialTypes.includes(type.id)
                    && quotations
                    && typeQuotes
                    && typeQuotes
                      .filter((quote) => isCompanyAllowed(quote, processingQuote))
                      .map((quote, index) => renderRiskCard(quote, index))}

                  {/* Commercial extra quote types */}
                  {processingQuote !== null
                    && processingQuote.company_id !== 1001
                    && commercialExtraQuoteTypes
                      .filter((extraType) => extraType.id === type.id && quotations?.[extraType.id])
                      .flatMap((extraType) => quotations[extraType.id]
                        .filter((quote) => isCompanyAllowed(quote, processingQuote))
                        .map((quote, idx) => renderRiskCard(quote, idx, extraType)))}

                  {quotations && typeQuotes && typeQuotes.length === 0 && (
                    <h5 className="fw-bold">Nessuna Quotazione Trovata</h5>
                  )}
                </div>
              </>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-danger px-4"
              data-bs-dismiss="modal"
            >
              Chiudi
            </button>
          </div>
        </div>
      </div>
    </ResultModal>
  );
}

export default ModalQuotes;
